import {Children, cloneElement, ReactElement} from "react";
import styles from './Tabs.module.scss'



export const Tabs = ({onChange, value, className, children, light}: {
  onChange: (tabIndex: number) => void,
  value?: number,
  className?: string,
  children: any,
  light?: boolean
}) => {

  const handleClick = (tabIndex: number) => {
    onChange(tabIndex)
  }

  return <ul className={`${className ? className : ''} ${styles.tabs} ${light ? styles.light : ''}`}>
    {Children.map(children, (child, index) => {
      return <li className={`${styles.tab}  ${value === index ? styles.tabActive : ''}`}>
        {cloneElement(child, {
          // props
          onClick: () => handleClick(index)
        })}
      </li>
    })}

  </ul>
}

export const Tab = ({children, onClick}: {
  children: any,
  onClick?: () => void,
}) => {
  return <button type={"button"} onClick={onClick}>{children}</button>;
}

export const TabPanel = ({value, index, children}: {
  value: number,
  index: number,
  children: any,
}) => {

  if (value !== index){
    return <></>;
  }

  return children

}
